
















import {Component, Emit, Prop, Vue} from "vue-property-decorator";

@Component({
components: {}
})
export default class VistaPreviaImagen extends Vue {
  @Prop() readonly url!: string;

  @Emit("cerrar")
  onCerrar(): void {
    return;
  }
}
